export default __webpack_public_path__ + "static/media/img-20-rune.94092131.jpg";